import React from 'react';
import '../../assets/css/case-home.css';
import caseBackgroundIcon from '../../assets/images/case-background-dark.svg';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken } from '@vibesites/runtime/react';

export function CareersPageHero() {
  const title = useContentToken('careerspagehero.title');

  return (
    <section className="case-aboutpage-hero">
      <div className="case-aboutpage-hero-overlay" role="presentation" aria-hidden="true">
        <img src={caseBackgroundIcon} alt="Case & Associates logo accent background" />
      </div>
      <div className="case-container">
        <nav aria-label="Breadcrumb">
          <ol className="case-breadcrumb">
            <li><a href="/">Home</a></li>
            <li aria-current="page">
              <EditableToken path="careerspagehero.title" type="text" label="Page Title" defaultValue={contentSchema.tokens['careerspagehero.title'].defaultValue} as="span">
                {title}
              </EditableToken>
            </li>
          </ol>
        </nav>
        <EditableToken
          path="careerspagehero.title"
          type="text"
          label="Page Title"
          defaultValue={contentSchema.tokens['careerspagehero.title'].defaultValue}
          as="h1"
          style={{ fontSize: '2.5rem', fontWeight: 700, lineHeight: 1.2, margin: '0.25rem 0 0' }}
        >
          {title}
        </EditableToken>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'CareersPageHero',
  displayName: 'Careers Page Hero',
  tokens: {
    'careerspagehero.title': {
      label: 'Page Title',
      type: 'text',
      defaultValue: 'Careers at Case & Associates',
    },
  },
};

(CareersPageHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default CareersPageHero;
